import { useCallback, useEffect, useState } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import fetchJson from "@/remoteState/fetchJson";

const useGetUserLicenses = () => {
  const [licenses, setLicenses] = useState([]);

  const getLicenses = useCallback(async () => {
    try {
      const userLicenses = await fetchJson(
        `${MONOLITH_ORIGIN}/api/v2/user/me/license/`,
      );

      if (userLicenses) {
        setLicenses(userLicenses);
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    getLicenses();
  }, [getLicenses]);

  return licenses;
};

export default useGetUserLicenses;
